import type {
	SpacerUmbBlockElementModel,
	SpacerUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { cn } from "tailwind-variants";
import { useContext } from "react";
import { BlockPreviewContext } from "#/_packages/umbrella/features/previews/block-preview-context";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";

type ISpacerBlockProps = BlockItemProps & {
	content: SpacerUmbBlockElementModel;
	settings: SpacerUmbBlockSettingsElementModel;
};

export default function SpacerUmbBlock({
	className,
	content,
	settings,
}: ISpacerBlockProps) {
	const isPreview = useContext(BlockPreviewContext);
	const alignment = settings.properties?.alignmentSelfVertical;
	return (
		<div
			id={settings.properties?.generatedId ?? undefined}
			className={cn(
				"block__spacer",
				alignment && ["start", "center", "end", "stretch"].includes(alignment)
					? `g-align-v-${alignment}`
					: undefined,
				className,
			)}
			style={{
				height: `calc(${content.properties?.verticalSize} * var(--umb-spacer-multiplier))`,
				...(isPreview
					? {
							backgroundImage:
								"linear-gradient(135deg, #ffffff 41.67%, #dddddd 41.67%, #dddddd 50%, #ffffff 50%, #ffffff 91.67%, #dddddd 91.67%, #dddddd 100%)",
							backgroundSize: "8.49px 8.49px",
						}
					: {}),
			}}
		></div>
	);
}
